import React from 'react';
import { BookOpenIcon, CheckIcon, GiftIcon, GlobeIcon, LockIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
import { SectionHeading } from '../SectionHeading';
import { IMAGES } from '../../data/landing';
const stack = [{
  icon: BookOpenIcon,
  title: 'Calm Response 5™',
  sub: '6 Premium Volumes + SOS cards, checklists, flowcharts & planner',
  value: '$97'
}, {
  icon: GiftIcon,
  title: '5 Exclusive Bonuses',
  sub: 'SOS Cards · 21-Day Planner · Pattern Map · Visual Routines · Do/Avoid Guide',
  value: '$147'
}];
const perks = ['One-time payment', 'Lifetime access', 'No monthly fees', 'Instant digital access'];
export function Offer() {
  return <section id="offer" className="bg-navy" data-id="element-258" data-mp="3nyod21d6n20g">
      <div className="mx-auto max-w-3xl px-3 py-14 sm:px-5 md:py-20" data-id="element-259" data-mp="3swzouhn1fmlb">
        <div className="px-2" data-id="element-260" data-mp="1pdq93f6eabb">
          <SectionHeading tone="dark" title={<>This is everything <em className="text-sun" data-id="element-262" data-mp="1klglajuwscjv">I'm giving you today</em></>} data-id="element-261" data-mp="1qot910sre1d" />
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl bg-white shadow-2xl" data-id="element-263" data-mp="1kjdnhdnilf4l">
          <img src={IMAGES.mainMockup} alt="Everything included in Calm Response 5™" className="block w-full bg-cream" data-id="element-264" data-mp="1fku0d9x6pxan" />

          <div className="p-5 sm:p-8" data-id="element-265" data-mp="1bmwby9b8nf8b">
            <ul className="divide-y divide-navy/10" data-id="element-266" data-mp="16m8n9uahfah9">
              {stack.map(s => {
              const Icon = s.icon;
              return <li key={s.title} className="flex items-start gap-3 py-4" data-id="element-267" data-mp="23e2c2pqylcxl">
                    <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-teal-soft text-teal-dark" data-id="element-268" data-mp="1zawbnyqj2fz1">
                      <Icon className="h-5 w-5" aria-hidden="true" data-id="element-269" data-mp="1uhjlvla4434p" />
                    </span>
                    <div className="min-w-0 flex-1" data-id="element-270" data-mp="1pigtb0bbjpdm">
                      <p className="text-lg font-black text-navy" data-id="element-271" data-mp="2n0714k2fgnxv">{s.title}</p>
                      <p className="text-sm leading-snug text-muted" data-id="element-272" data-mp="2i9ib796ebz0u">{s.sub}</p>
                    </div>
                    <span className="shrink-0 text-lg font-extrabold text-muted line-through" data-id="element-273" data-mp="314z1mq89s5d5">{s.value}</span>
                  </li>;
            })}
            </ul>

            <div className="mt-2 flex items-center justify-between rounded-2xl bg-cream px-4 py-3" data-id="element-274" data-mp="2sd5fmo9z22g6">
              <span className="font-black uppercase tracking-wide text-navy" data-id="element-275" data-mp="2weqxyp59z8xr">Total value</span>
              <span className="text-xl font-black text-coral-dark line-through" data-id="element-276" data-mp="2iezh8gndjeg2">$244</span>
            </div>

            <div className="mt-6 space-y-1 text-center text-base text-muted" data-id="element-277" data-mp="2ndswadib7dic">
              <p data-id="element-278" data-mp="2nbpw50ng03zw">You don't need another subscription.</p>
              <p data-id="element-279" data-mp="29fmfyb9elw6f">You don't need another complicated parenting course.</p>
              <p data-id="element-280" data-mp="2dfd384zq1u67">You don't need to spend hours watching videos.</p>
            </div>

            <div className="mt-6 text-center" data-id="element-281" data-mp="7n7puowphlex">
              <p className="text-lg font-bold text-navy" data-id="element-282" data-mp="7ng34hwqqsqn">But today, I'm giving you the complete system for:</p>
              <p className="mt-2 font-display text-[22px] font-bold uppercase text-muted" data-id="element-283" data-mp="bnqjmoi5t1jr">Only</p>
              <p className="font-display text-[88px] font-bold leading-none text-cta-dark sm:text-[112px]" data-id="element-284" data-mp="1w6u1cusgmasi">$27</p>
              <p className="mt-2 text-sm font-black uppercase tracking-wider text-navy" data-id="element-285" data-mp="1s2w3enevf611">One-time payment</p>
            </div>

            <ul className="mt-6 grid grid-cols-2 gap-2" data-id="element-286" data-mp="215x5md0m8czf">
              {perks.map(p => <li key={p} className="flex items-center gap-2 rounded-xl bg-teal-soft px-3 py-2.5 text-sm font-extrabold text-navy" data-id="element-287" data-mp="2fujnomhmniuc">
                  <CheckIcon className="h-4 w-4 shrink-0 text-teal-dark" strokeWidth={3} aria-hidden="true" data-id="element-288" data-mp="2auf4gopc4a0f" />
                  {p}
                </li>)}
            </ul>

            <div className="mt-5 flex items-start gap-3 rounded-2xl border border-navy/10 bg-navy-soft p-4" data-id="element-289" data-mp="2jvwrkr15tbym">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-navy" aria-hidden="true" data-id="element-290" data-mp="ui9sl0x24slh" />
              <p className="text-[15px] leading-snug text-navy" data-id="element-291" data-mp="pix7aklu3tl0">
                <strong data-id="element-292" data-mp="rwsm0wqqi0fe">Automatic currency conversion.</strong> The price is shown in USD and is converted to your local currency automatically at checkout.
              </p>
            </div>

            <div className="mt-5" data-id="element-293" data-mp="w08hhpr2huqi">
              <ScarcityBar data-id="element-294" data-mp="10x783ybivjjy" />
            </div>

            <div className="mt-6" data-id="element-295" data-mp="10ya0ybsenw2i">
              <CTAButton label="Yes, I want Calm Response 5™" microcopy="Only $27 · Instant Access · Lifetime Access · 7-Day Guarantee" data-id="element-296" data-mp="15wbfqkist986" />
            </div>

            <div className="mt-6" data-id="element-297" data-mp="8amib2ap3fii">
              <Countdown data-id="element-298" data-mp="d7modd7joi9m" />
            </div>

            <p className="mt-6 flex items-center justify-center gap-1.5 text-center text-sm font-bold text-muted" data-id="element-299" data-mp="d8o0zm47lctg">
              <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-300" data-mp="i5o5hsleu7ig" />
              Secure checkout · Instant delivery by email
            </p>
          </div>
        </div>
      </div>
    </section>;
}